import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { getZoneModules } from '../../redux/selectors/zones';
import s from './Zone.scss';
const Zone = ({ className, mapModuleTypeToWidgetConfig, type, direction = 'column' })=>{
    const zoneModules = useSelector((state)=>getZoneModules(state, type));
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className, s[direction]),
        key: type
    }, zoneModules.map((module, index)=>{
        const widgetConfig = mapModuleTypeToWidgetConfig[module.name];
        if (!widgetConfig) {
            return null;
        }
        const { viewComponent: WidgetComponent, configPopoverComponent } = widgetConfig;
        const widgetBoxProps = {
            configPopoverComponent
        };
        return /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "Zone",
            key: index
        }, /*#__PURE__*/ React.createElement(WidgetComponent, {
            key: index,
            moduleId: module.id,
            widgetBoxProps: widgetBoxProps
        }));
    }));
};
Zone.displayName = 'Zone';
export default Zone;
